/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import styled from '@emotion/styled';
import tw from 'twin.macro';
import { StyleProps } from '$/components/ui';
import { ButtonProps } from './Button/Button';
import Button from './Button';

const UhOh: React.FC<StyleProps> & any = styled.span`
  ${tw`font-normal font-body text-color-input-field`}
`;

const Container: React.FC<{ className?: string; children: React.ReactNode }> = ({
  children,
  className,
}) => (
  <div
    className={`container mx-auto flex flex-col w-full h-full justify-center items-center pb-8e ${className}`}
  >
    {children}
  </div>
);

UhOh.Title = styled(UhOh.withComponent('h1'))`
  ${tw`font-title font-light leading-none text-4xl md:text-6xl text-center mx-8 mb-0`}
  & + * {
    margin-top: 1rem;
  }
`;

UhOh.Body = styled(UhOh.withComponent('div'))`
  ${tw`text-color-setting text-md md:text-xl leading-normal w-10/12 md:w-8/12 text-center my-2_5e`}
  p {
    margin-top: 1rem !important;
  }
`;

const UButton: React.FC<ButtonProps> = ({ children, className, ...props }) => (
  <Button.rounded className={`px-3e text-xl ${className}`} {...props}>
    {children}
  </Button.rounded>
);

UhOh.Note = styled(UhOh.withComponent('div'))`
  ${tw`text-base text-color-setting leading-snug w-full px-2e my-2e`}
`;

UhOh.Error = styled(UhOh.withComponent('div'))`
  ${tw`text-base text-color-setting text-center leading-snug w-full px-2e mt-1e`}
`;

UhOh.Container = Container;
UhOh.Button = UButton;

export default UhOh;
